'use strict';
var defineProperty = require('../internals/object-define-property').f;

module.exports = function (Target, Source, key) {
  key in Target || defineProperty(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/proxy-accessor.js
// module id = 339
// module chunks = 0